/**
 * Formate une durée (ms) en horloge pour le chrono d'exercice.
 *   < 1 h  → `M:SS`     (ex. `7:03`)
 *   ≥ 1 h  → `H:MM:SS`  (ex. `1:05:09`)
 *
 * Les minutes ne sont zéro-paddées que lorsqu'il y a des heures (sinon `7:03`,
 * pas `07:03`). Les secondes sont toujours sur deux chiffres. Les valeurs
 * négatives (horloge non démarrée) sont ramenées à `0:00`.
 */
export function formatTimer(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);
  const ss = String(seconds).padStart(2, '0');
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${ss}`;
  }
  return `${minutes}:${ss}`;
}

/**
 * Compte à rebours « grossier » pour un passe non urgent (≥ 1 h restante) :
 *   ≥ 1 j → `Xj Yh`
 *   ≥ 1 h → `Yh ZZmin`
 *   < 1 h → `ZZmin`
 * Pour un passe 24 h proche de l'expiration, préférer `formatTimer` (H:MM:SS
 * vivant à la seconde). Renvoie `Expiré` à 0 ou en dessous.
 */
export function formatPassRemaining(remainingMs: number): string {
  if (remainingMs <= 0) return 'Expiré';
  const totalMinutes = Math.floor(remainingMs / 60_000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days >= 1) return `${days}j ${hours}h`;
  if (hours >= 1) return `${hours}h ${minutes}min`;
  return `${minutes}min`;
}
